// extracted by mini-css-extract-plugin
export default {"entityIdField":"EntityIdField_entityIdField__mofqE"};